'use strict';

/**
 *
 * @name: brightcoveNew
 *
 */

import DirectiveTemplate from './nn-player-brightcove-new.directive.html';
// import brightcovePlugin from './brightcove-plugin'
import './brightcove-stylesheet.scss'
import './nn-player-brightcove-new.directive.scss'

function BrightcoveNewDirective($rootScope, localPlaylist, APP_CONSTANTS, brightcoveNewHelperServ, $timeout) {
  'ngInject';
  console.log($rootScope, localPlaylist, APP_CONSTANTS, brightcoveNewHelperServ, $timeout)

  return {
    restrict: 'CA',
    replace: true,
    transclude: false,
    scope: {
      videoId: '@',
      videoPoster: '@',
      videoVtt: '@',
      rememberProgress: '=',
      videoUrl: '@'
    },
    template: DirectiveTemplate,
    link: function (scope, $element) {
      console.log(scope, $element)

      /*
       *
       * @CONFIG
       *
       */

      var player, script, detached, cssLink;
      detached = true;

      scope.reduceCaptionSize = scope.videoId === '6165639239001';
      scope.brightcovePlayerId = $rootScope.lang === 'zh-cn' ? APP_CONSTANTS.brightcovePlayerIdCn : APP_CONSTANTS.brightcovePlayerIdEn;

      /*
       *
       * @PUBLIC
       *
       */

      scope.togglePlay = () => {
        if ($element[0].paused) {
          player.play()
        } else {
          player.pause()
        }
      }

      /*
       *
       * @PRIVATE
       *
       */

      function _initPlayer() {

        // This script has to be loaded for every instance of the player.
        // It contains some initialization logic that is not standard for
        // videojs and is not described in docs

        cssLink = document.createElement('link');
        $element[0].appendChild(cssLink);
        cssLink.setAttribute('rel', 'stylesheet');
        cssLink.setAttribute('href', 'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css');



        script = document.createElement('script');
        $element[0].appendChild(script);
        script.onload = _setupPlayer;
        // script.setAttribute('src', '//players.brightcove.net/2385340575001/' + scope.brightcovePlayerId + '_default/index.min.js');
        script.setAttribute('src', 'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js');







        $element.on('$destroy', function () {

          script = null;

          if (scope.rememberProgress) {

            brightcoveNewHelperServ.saveVideoProgress(player.currentTime(), scope.videoId);
          }


        });


        /* private */
        function _setupPlayer() {

          // const registerPlugin = videojs.registerPlugin || videojs.plugin;

          // player = videojs('bc-player');
          // player.currentTime(brightcoveNewHelperServ.getVideoProgress(scope.videoId));
          // brightcoveNewHelperServ.resetVideoProgress();
          // registerPlugin('brightcovePlugin', brightcovePlugin)

          // // to show persisten player


          // player.on('ended', _onEnded);
          // player.on('loadedmetadata', _onLoadedMetaData);

          // if (!$rootScope.isMobileDevice) {
          //   player.on('timeupdate', _onTimeUpdate);
          // }

          // player.on('ready', () => {
          //   player.brightcovePlugin();
          // });
          // console.log(scope,999);
          player = new window.Aliplayer({
            id: 'J_prismPlayer',
            width: '100%',
            autoplay: false,
            height: '100%',
            controlBarVisibility: 'hover',
            //支持播放地址播放,此播放优先级最高
            source: scope.videoUrl,
            cover: scope.videoPoster,
            // skinLayout: [
            //   {name: 'bigPlayButton', align: 'blabs', x: '47%', y: '45%'},
            //   { name: 'H5Loading', align: 'cc' },
            //   {name:"tooltip", align:"blabs",x: 0, y: 56},
            //   { name: 'controlBar', align: 'blabs', x: 0, y: 0,
            //     children: [
            //       {name: 'progress',align:'tlabs', x: 0, y: 0},
            //       {name: 'playButton', align: 'tl', x: 15, y: 12},
            //       {name: 'timeDisplay', align: 'tl', x: '43%', y: 3},
            //       {name: 'fullScreenButton', align: 'tr', x: 20, y: 12},
            //       {name: 'volume', align: 'tr', x: 20, y: 10},
            //       // {name: 'subtitle', align:"tr",x:20, y:12},
            //     ]
            //   }
            // ],
            skinLayout: [
              { name: 'bigPlayButton', align: 'blabs', x: '47%', y: '45%' },
              { name: 'H5Loading', align: 'cc' },
              { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
              { name: 'infoDisplay' },
              { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
              { name: 'thumbnail' },
              {
                name: 'controlBar', align: 'blabs', x: 0, y: 0,
                children: [
                  { name: 'progress', align: 'blabs', x: 0, y: 44 },
                  { name: 'playButton', align: 'tl', x: 15, y: 12 },
                  { name: 'timeDisplay', align: 'tl', x: '43%', y: 3 },
                  { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
                  // { name: "subtitle", align: "tr", x: 15, y: 12 },
                  { name: 'setting', align: 'tr', x: 15, y: 12 },
                  { name: 'volume', align: 'tr', x: 5, y: 10 }
                ]
              }
            ]

            //播放方式二：点播用户推荐
            // vid : '1e067a2831b641db90d570b6480fbc40',
            // playauth : 'ddd',
            // cover: 'http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png',
            // encryptType:1, //当播放私有加密流时需要设置。
            // //播放方式三：仅MPS用户使用
            // vid : '1e067a2831b641db90d570b6480fbc40',
            // accId: 'dd',
            // accSecret: 'dd',
            // stsToken: 'dd',
            // domainRegion: 'dd',
            // authInfo: 'dd',
            // //播放方式四：使用STS方式播放
            // vid : '1e067a2831b641db90d570b6480fbc40',
            // accessKeyId: 'dd',
            // securityToken: 'dd',
            // accessKeySecret: 'dd',
            //  region:'cn-shanghai',//eu-central-1,ap-southeast-1
          }, function () {
            console.log('播放器创建好了。')
          });
          // https://blog.csdn.net/u014705309/article/details/105048145
          var _video = document.querySelector('video');

          var subtitleArr = JSON.parse(scope.videoVtt)
          console.log(subtitleArr)

          // const cueCn = new VTTCue(0, 10.00, '字幕会在0至10秒间显示');
          // tracks[0].addCue(cueCn);
          // var subtitleArr = [
          //   {title:'中文',link:'https://nowness-a.akamaihd.net/pd/2385340575001/201705/2008/2385340575001_0edd5f14-6130-4558-af70-fa92568b0a58.vtt?pubId=2385340575001&videoId=5434360453001'},
          //   {title:'英文',link:'https://nowness-a.akamaihd.net/pd/2385340575001/201511/2337/2385340575001_4266663e-275c-4c5b-9b30-5e3a4242df55.vtt?pubId=2385340575001&videoId=4065728746001'},
          // ]
          subtitleArr.forEach((element,index) => {
            getVtt(element,index);
          });

          let tracks = _video.textTracks;
          function getVtt(element,index) {
            fetch(element.FileURL, {
              method: 'GET'
            }).then((res) => res.text()).then(res => {
              console.log(res)
              _video.addTextTrack('subtitles', element.tags, element.tags);

              const arr = res.split('\n');
              for (let i = 0; i < arr.length; i++) {
                const line = arr[i];
                if (line.indexOf('-->') > -1) {
                  const cue = line.split('-->');
                  const startTime = cue[0].trim();
                  const endTime = cue[1].trim();
                  const text = arr[i + 1];
                  const textTrackCue = new window.VTTCue(getMil(startTime), getMil(endTime), text);
                  textTrackCue.id = i + 1;
                  tracks[index].addCue(textTrackCue);
                  i++;
                }
              }
            });
          }
          function getMil(time) {
            let result = 0;
            const time1 = time.split('.')[0].split(':');
            time1.map((item, index) => {
              let num = Number(item);
              for (let i = 0; i < (2 - index); i++) {
                num = num * 60
              }
              result += num
            });
            result += Number('0.' + time.split('.')[1]);
            return result
          }
          // function()


          player.on('play', function () {
            _video.removeEventListener('click', play);
            _video.addEventListener('click', pause);
          });
          player.on('pause', function () {
            _video.removeEventListener('click', pause);
            _video.addEventListener('click', play)
          });

          function play() {
            if (player) player.play();
          }

          function pause() {
            if (player) player.pause();
          }
          $rootScope.noPlayer = false;
        }


        // function _onLoadedMetaData() {

        //   /*jshint validthis: true */
        //   var player = this;
        //   $rootScope.playerSubtitles = player.mediainfo.textTracks;
        // }

        // function _onEnded() {

        //   scope.$apply(function() {

        //     $rootScope.$broadcast('filmDun');
        //     $rootScope.showPersistentVideo = false;
        //     $rootScope.noPlayer = true;
        //   });
        // }

        // function _onTimeUpdate() {

        //   /*jshint validthis:true */
        //   var counter = Math.floor(this.duration() - this.currentTime());
        //   if (counter < 0) {
        //     counter = 0;
        //   }

        //   if (counter < 888888) {
        //     $timeout(function() {
        //       localPlaylist.updateCounter(counter);
        //     });
        //   }
        // }
      }


      /*
       *
       * @INIT
       *
       */


      if ($element[0].parentNode.nodeName === 'DIV') {
        detached = false;
      }

      if (detached) {
        $element.parents().remove();
        $element.remove();
      }

      else {
        _initPlayer();

      }
    }
  };
}

export default BrightcoveNewDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-player-brightcove/nn-player-brightcove-new.directive.js